export default __webpack_public_path__ + "media/images/icons/logo-56641925e1b3e3096ca3f641bbab5f0e.svg";